import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import * as actions from "../../store/slices/HealthCoachSlice";
import { useEffect } from "react";
import { toast } from 'react-toastify';
import { constants } from "../../constants/common";

export interface PatientTableProps {
  patientData: any;
  isVivitraEnabled: boolean;
  dataSource: any[];
  isLoading: boolean;
}

const usePatientTable = (props: PatientTableProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateVisitDetailsState: { isLoading, errors, data} } = useSelector((state: RootState) => state.healthCoach);
  const { patientData, isVivitraEnabled, dataSource } = props;
  const onActionClick = (record: any) => {
    // console.log("record", record);
    const token = localStorage.getItem("token");
    navigate(`/cycle-details/:token`, {
      state: {
        cycleNumber: record.visit_cycle,
        patientId: patientData.patient_id,
        support_program_drug: patientData.patient_meta_info?.support_program_drug,
        visitID: record.patient_visit_id,
        token: token,
        visitStatus: record.visit_status,
        visitMetaInfo: record.visit_meta_info,
        vivitraEligible: isVivitraEnabled,
      },
    });
  };

  useEffect(() => {
    if(!isLoading) {
      if(errors) {
        toast.error(errors || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      }
    }
  }, [isLoading, errors, data]);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>, record: any) => {
      try {
        const body = {
          patient_phone: patientData.contact_no,
          patient_name: patientData.name,
          patient_visit_id: record.patient_visit_id,
          reschedule_date: e.target.value,
          updated_by: record.updated_by,
        };
        console.log("body ===>", body);
        dispatch(actions.updateVisitDetailsRequest(body));
    } catch (error) {
      console.error("Error while rescheduling the visit:", error);
    }
  };
  const formattedDate = (record: any) => {
    return moment(record.rescheduled_date || record.visit_date).format(
      "YYYY-MM-DD"
    );
  };

  return {
    data,
    errors,
    isLoading,
    onActionClick,
    formattedDate,
    handleDateChange,
  };
};

export default usePatientTable;
